<template>
  <!-- <div class="max-w-7xl mx-auto"> -->
  <div class="w-full">
    <RouterView></RouterView>
  </div>
</template>
